import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.8882 11.0273C35.7611 11.0528 31.9638 12.3083 27.4498 13.8181L19.2402 16.558L28.6851 16.5631L38.1248 16.5682V14.5399C38.1248 12.2982 38.1248 12.2982 37.7893 11.8051C37.3928 11.2256 36.5897 10.9003 35.8882 11.0273Z"
        fill={colourFill}
      />
      <path
        d="M3.76167 18.7337C1.91133 19.1302 0.4575 20.584 0.0813333 22.4242C0.0101667 22.78 0 24.5846 0 40.7903V58.765L25.864 58.7497L51.7229 58.7345L52.0533 58.6175C52.6481 58.4142 53.0598 58.0228 53.2733 57.4585C53.375 57.184 53.375 57.0824 53.375 52.2278V47.2715H42.7559C32.269 47.2715 32.1317 47.2715 31.8166 47.1699C31.2371 46.9869 30.8152 46.5853 30.6017 46.016C30.5 45.7415 30.5 45.6805 30.5102 39.5296L30.5254 33.3178L30.6627 33.0535C30.8558 32.6875 31.0541 32.474 31.4302 32.23L31.7505 32.0215H40.1939C44.835 32.0215 49.6997 32.0063 51.0062 31.986L53.375 31.9555L53.3648 25.9775L53.3496 19.9995L53.2377 19.7555C53.0802 19.42 52.6532 18.9828 52.3126 18.8201L52.0279 18.6778L28.06 18.6676C7.7165 18.6625 4.04125 18.6727 3.76167 18.7337Z"
        fill={colourFill}
      />
      <path
        d="M33.0113 34.3446C32.8028 34.3853 32.7876 34.7563 32.7876 39.6262C32.7876 44.4808 32.8028 44.8112 33.0113 44.8569C33.0672 44.8722 33.2197 44.9027 33.3468 44.9332C33.4942 44.9637 37.1796 44.984 43.4778 44.984H53.3751V39.6465V34.309L43.2491 34.3141C37.6778 34.3192 33.0672 34.3344 33.0113 34.3446ZM40.0568 39.6211V41.5273H38.1251H36.1934V39.6211V37.7148H38.1251H40.0568V39.6211Z"
        fill={colourFill}
      />
      <path
        d="M0.132062 60.8796C0.152396 60.9609 0.228646 61.1897 0.304896 61.393C0.874229 62.8774 2.22131 64.011 3.78698 64.321C4.15806 64.3973 6.18631 64.4024 26.2045 64.3922L48.2153 64.377L48.5 64.2346C48.8406 64.072 49.2676 63.6348 49.4251 63.2993C49.5268 63.0756 49.537 62.9638 49.5522 61.8963L49.5675 60.7423H24.832H0.101562L0.132062 60.8796Z"
        fill={colourFill}
      />
    </svg>
  );
};

export default ServiceIcon;
